import antdData from 'antd/lib/locale-provider/pl_PL'
import localeData from 'react-intl/locale-data/pl'
import countries from './countries/pl.json'
import languages from './languages/pl.json'
import platform from './platform/pl.json'
import urls from './urls/pl.json'
import texts from './texts/pl.json'
import faq from './faq/pl.json'

export default {
  locale: 'pl',
  antdData,
  localeData,
  messages: {...texts, ...countries, ...languages, ...platform, ...urls, ...faq },
}
